module.exports = __webpack_public_path__ + "img/server-side.445be871.svg";